export default {
  getEditableOperator: ({ operator }) => operator || {},
  authorizationLevel: state => state.authorizationLevel,
};
